import type { Split } from 'type-fest';

export const split = <S extends string, D extends string>(
  str: S,
  separator: D,
) => {
  return str.split(separator) as Split<S, D>;
};
